
export default function () {
    $(document).ready(function () {
        $('.block--featured-resources').each(function () {
            const block = $(this);

            block.find('.basic-tabs__tab-button').on('click', function () {
                let tab = $(this).data('tab-contents-id');

                block
                    .find('.basic-tabs__tab-button')
                    .removeClass('--active');
                $(this).addClass('--active');

                block
                    .find('.featured-resources__tab-content')
                    .removeClass('featured-resources__tab-content--active')
                    .hide();

                const $activeTabContent = block.find(
                    `.featured-resources__tab-content[data-tab-contents-id="${tab}"]`
                );

                $activeTabContent.addClass('featured-resources__tab-content--active');
                $activeTabContent.show();
            });

            block.find('.basic-tabs__tab-buttons-mobile .dropdown-menu__button').on('change', function () {
                let tab = $(this).val();

                block
                    .find('.featured-resources__tab-content')
                    .removeClass('featured-resources__tab-content--active')
                    .hide();

                const $activeTabContent = block.find(
                    `.featured-resources__tab-content[data-tab-contents-id="${tab}"]`
                );

                $activeTabContent.addClass('featured-resources__tab-content--active');
                $activeTabContent.show();

                // Set swipe view.
                block.find('.tabs--swipe-stack > *').removeClass('--active');
                block.find('.tabs--swipe-stack [data-tab-contents-id="swipe-stack-0"]').addClass('--active');
                swipeOption(block);
            });

            block.find('.basic-tabs__tab-buttons-mobile .tabs--swipe-stack .tabs--swipe-stack-button').on('click', function () {
                let tab = $(this).data('tab-contents-id');

                block
                    .find('.tabs--swipe-stack-button')
                    .removeClass('--active');
                $(this).addClass('--active');

                if (tab == "swipe-stack-1") {
                    stackOption(block);
                }

                if (tab == "swipe-stack-0") {
                    swipeOption(block);
                }
            });

            const $firstTab = block.find('.basic-tabs__tab-button').first();
            if ($firstTab.length > 0) {
                $firstTab.trigger('click');
                block
                    .find('.featured-resources__tab-content--active')
                    .removeClass('stack')
                    .addClass('swipe');

                swipeOption(block);
            }
        });

        // Function to initialize the Slick slider inside each tab
        function initializeSlick($slider) {
            if ($slider.length > 0) {
                if ($slider.hasClass('slick-initialized')) {
                    $slider.slick('unslick');
                }
                $slider.addClass('slick');

                $slider.slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    arrows: true,
                    infinite: false,
                    centerMode: true,
                    centerPadding: '10px',
                });
            }
        }

        // UnInit slick.
        function destroySlick($slider) {
            $slider.slick('unslick');
        }

        // Add Swipe Option.
        function swipeOption(block) {
            block
                .find('.featured-resources__tab-content--active')
                .removeClass('stack')
                .addClass('swipe');

            if (isMobile()) {
                // Init Slick.
                initializeSlick(block.find('.featured-resources__tab-content--active.swipe .featured-resources__cards'));
            }
        }

        // Add Swipe Option.
        function stackOption(block) {
            block
                .find('.featured-resources__tab-content--active')
                .removeClass('swipe')
                .addClass('stack');

            // Destroy Slick.
            destroySlick(block.find('.featured-resources__cards'));
        }

        function isMobile() {
            return window.matchMedia("(max-width: 800px)").matches || navigator.maxTouchPoints > 0;
        }
    });
}

